import { createContext, useContext, useEffect, useId } from 'react';

/**
 * Занятость полей формы (например, идёт загрузка файла): пока хоть одно поле занято, FormDialog
 * не отправляет форму — иначе в запрос ушло бы значение без загруженного файла.
 */
export interface FormBusyRegistry {
  setBusy: (id: string, busy: boolean) => void;
}

export const FormBusyContext = createContext<FormBusyRegistry | null>(null);

export function useFormBusy(busy: boolean): void {
  const registry = useContext(FormBusyContext);
  const id = useId();
  useEffect(() => {
    if (!registry) return;
    registry.setBusy(id, busy);
    return () => registry.setBusy(id, false);
  }, [registry, id, busy]);
}
